import { ChevronDoubleRightIcon, FilterIcon } from '@vlabs/icons';
import { Badge, Control } from '@vlabs/uikit';
import type { ButtonProps } from '@vlabs/uikit/components/controls/button/Button';
import { useTranslation } from 'react-i18next';

import { useFilterMenu } from './FilterMenuContext';
import { usePageContext } from '../page/usePageContext';

export interface FilterMenuButtonProps extends Omit<ButtonProps, 'badge'> {
  filtersCount?: number;
}

function FilterMenuButton({
  filtersCount = undefined,
  ...props
}: FilterMenuButtonProps): JSX.Element {
  const { buttonSize } = usePageContext();
  const { isOpen, toggleIsOpen } = useFilterMenu();
  const { t } = useTranslation();

  return (
    <Control.Button
      badge={filtersCount ? <Badge value={filtersCount} /> : undefined}
      data-testid="filterMenu.button"
      icon={isOpen ? <ChevronDoubleRightIcon /> : <FilterIcon />}
      kind={isOpen ? 'secondary' : 'primary'}
      onClick={toggleIsOpen}
      size={buttonSize}
      variant={isOpen ? 'filled' : 'outlined'}
      {...props}
    >
      {t('фильтры')}
    </Control.Button>
  );
}

export { FilterMenuButton };
